import { jsx as e } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { DateInput as l } from "../../DateInput/DateInput.mjs";
import { CalendarIcon as u } from "../../../../icons/componentIcons.mjs";
const d = f(
  ({ onChange: r, onClick: n, onFocus: o, ...a }, m) => /* @__PURE__ */ e(
    l,
    {
      ref: m,
      onChange: (i, t) => {
        if (t.event) {
          const { event: p } = t;
          p.currentTarget.value = i.formattedValue, r(t.event);
        }
      },
      onFocus: o,
      onClick: n,
      width: "100%",
      inputRightElement: /* @__PURE__ */ e(u, { color: "teal.500", size: "md", variant: "light" }),
      ...a
    }
  )
);
d.displayName = "CustomInput";
export {
  d as CustomInput
};
